import { IError } from "itsf-ui-common";
import { ReactNode } from "react";
import { Error } from "./Error";
import { Loader } from "@common/Loader/Loader";
import { Box } from "@mui/material";

interface ILoaderAndError {
    children: ReactNode;
    error?: IError;
    errorComponent?: ReactNode;
    hideComponentWrapper?: boolean;
    isHomePage?: boolean;
    isLoading: boolean;
    retryFetch?(): void;
}

export const HandleErrorAndLoading = (props: ILoaderAndError) => {
    const { children, isHomePage, error, errorComponent, hideComponentWrapper, isLoading, retryFetch } = props;
    const showLoader = !error && isLoading;

    let element = children;

    if (error) {
        element = errorComponent ? (
            errorComponent
        ) : (
            <Error error={error} isHomePage={isHomePage} retryFetch={retryFetch} />
        );
    } else if (showLoader) {
        element = <Loader />;
    } else if (hideComponentWrapper) {
        return <>{element}</>;
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <Box paddingY={2}>{element}</Box>;
};
